import {put} from 'redux-saga/effects';
import config from '../../config';
import * as serviceCaseActionTypes from '../serviceCaseActionTypes';

const loadServiceCaseSearchResults = function* loadServiceCaseSearchResults(payload) {
    if (!payload) return;
    const {location} = payload.payload;
    const searchQueryParams = new URLSearchParams(location.search);
    if (!searchQueryParams.get('size')) searchQueryParams.append('size', `${config.DEFAULT_PAGE_SIZE}`);

    yield put({
        type: serviceCaseActionTypes.SEARCH_SERVICE_CASES,
        payload: {searchQueryParams},
    });
    window.sessionStorage.setItem('serviceCaseOriginRoute', location.pathname);
};

export default loadServiceCaseSearchResults;
